import type {BioentitySummary} from 'folder-items/FileConstants';
import type {ValidationErrorData} from 'registry/RegistryValidatorStore';
import type {SchemaValidationErrorRecord, SchemaValidationState} from 'schemas/SchemaValidationConstants';

export const REGISTRY_EVENT_PAYLOADS = {
  REGISTRY_ACTIVATED: {} as {
    registryId: string;
  },

  REGISTRY_VALIDATOR_VALIDATE_FILE_TAGS_COMPLETED: {} as {
    errors: Array<SchemaValidationErrorRecord>;
    fileId: string;
  },
  REGISTRY_VALIDATOR_BULK_VALIDATE_FILE_TAGS_COMPLETED: {} as {
    errorsByFileId: {[fileId: string]: Array<SchemaValidationErrorRecord>};
  },

  REGISTRY_VALIDATOR_CHECK: {} as {},
  REGISTRY_VALIDATOR_CHECK_COMPLETED: {} as {
    myCollectionErrorsByFileId: {[fileId: string]: ValidationErrorData};
    orgCollectionErrorsByFileId: {[fileId: string]: ValidationErrorData};
    files: Array<BioentitySummary>;
    addedFileIds: Array<string>;
  },
  REGISTRY_VALIDATOR_MOVE: {} as {},
  REGISTRY_VALIDATOR_CANCEL: {} as {},
  REGISTRY_VALIDATOR_MOVE_COMPLETED: {} as {
    fileIds: Array<string>;
  },

  BIOENTITIES_VALIDATION_STATUS_UPDATED: {} as {
    schemaValidationStateByBioentityId: {[bioentityId: string]: SchemaValidationState | null};
  },
  COMPUTED_TAGS_UPDATED_AFTER_REGISTRATION_ACTION: {} as {
    entryId: string;
    fileSummariesById: {[id: string]: BioentitySummary};
    provenanceUuid: string;
  },
} as const;

export type RegistryEventPayload = typeof REGISTRY_EVENT_PAYLOADS;
